@if (isRmbRmc) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | translate }}</p>
}

<nh-alert type="warning" [isOpen]="showAlert()">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt="warning"
      />
    </div>
    <div class="col message">
      <span>{{ "SSN_ENTER_MANDATORY" | translate }} </span>
    </div>
  </div>
</nh-alert>

<div class="d-flex align-items-center">
  <h1 class="person-label">{{ "HOH" | translate }}:</h1>
  <span class="ps-2 pb-1">{{ head | fullname }} </span>
</div>

<nh-form
  [topLevelName]="'heco'"
  [topLevelName]="'heco'"
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  topLevelQuestion="{{ 'TOP_LEVEL_QUESTION' | translate }}"
  (validate)="onValidate($event)"
  class="label-section"
>
  <section>
    <fieldset [formGroup]="getControl('data')">
      <h2 class="section-header">{{ "HEALTH_INSURANCE" | translate }}</h2>
      <hr />
      <section [formGroup]="getControl('data.policyHolder')">
        <nh-field
          id="heco_houseMember"
          label="{{ 'POLICY_HOLDER' | translate }}"
          class="label-section"
        >
          <select
            nh
            name="individual"
            [attr.aria-required]="true"
            [attr.aria-label]="'POLICY_HOLDER' | translate"
            [items]="indi"
            bindLabel="name.fullName"
            bindValue="identifier"
            [formControl]="getControl('data.policyHolder.houseMember')"
            (change)="update()"
            [attr.disabled]="exported ? true : null"
          ></select>
        </nh-field>

        @if (isEnabled('data.policyHolder.policyHolderFirstName')) {
        <div>
          <nh-field
            id="heco_policyHolderFirstName"
            label="{{ 'POLICY_HOLDER_FIRSTNAME' | translate }}"
            class="label-section"
          >
            <input
              type="text"
              name="policyHolderFirstName"
              maxlength="46"
              class="form-control"
              formControlName="policyHolderFirstName"
              [attr.aria-label]="'POLICY_HOLDER_FIRSTNAME' | translate"
            />
          </nh-field>
          @if (isEnabled('data.policyHolder.policyHolderLastName')) {
          <nh-field
            id="heco_policyHolderLastName"
            label="{{ 'POLICY_HOLDER_LASTNAME' | translate }}"
            class="label-section"
          >
            <input
              type="text"
              name="policyHolderLastName"
              maxlength="46"
              class="form-control"
              formControlName="policyHolderLastName"
              [attr.aria-label]="'POLICY_HOLDER_LASTNAME' | translate"
            />
          </nh-field>
          } @if (isEnabled('data.policyHolder.dobDate')) {
          <nh-field
            id="heco_dobDate"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'DOB' | translate }}"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                class="form-control"
                name="dobDate"
                formControlName="dobDate"
                [minDate]="minimumDate"
                bsDatepicker
                [maxDate]="today"
                nh
                [attr.aria-label]="'DOB' | translate"
                (change)="isInvalidDate($event)"
              />
            </nh-datepicker>
          </nh-field>
          } @if (isEnabled('data.policyHolder.ssnNum')) {
          <nh-field
            id="heco_ssnNum"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="{{ 'SSN' | translate }}"
            class="label-section"
          >
            <nh-popover
              field-label
              class="ml-2 ps-1"
              content="{{ 'SSN_STATIC_TEXT' | translate }}"
            ></nh-popover>
            <input
              type="text"
              name="ssnNum"
              formControlName="ssnNum"
              class="form-control"
              placeholder="XXX-XX-XXXX"
              mask="000-00-0000"
              [attr.aria-label]="'SSN' | translate"
            />
          </nh-field>
          }
        </div>
        }
      </section>

      <nh-field
        id="heco_coverageType"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT1' | translate }} {{
          otherSelectedIndividual && otherSelectedIndividual !== ''
            ? otherSelectedIndividual
            : policyHolderFirstName.value !== null &&
              policyHolderLastName.value !== null
            ? policyHolderFirstName.value + '   ' + policyHolderLastName.value
            : ''
        }} {{ 'HEALTH_INSURANCE_STATIC_TEXT2' | translate }}"
        class="label-section"
      >
        <select
          nh
          name="coverageType"
          [attr.aria-required]="true"
          [attr.aria-label]="
            ('HEALTH_INSURANCE_STATIC_TEXT1' | translate) +
            ' ' +
            (otherSelectedIndividual && otherSelectedIndividual !== ''
              ? otherSelectedIndividual
              : policyHolderFirstName.value !== null &&
                policyHolderLastName.value !== null
              ? policyHolderFirstName.value + '   ' + policyHolderLastName.value
              : '') +
            ' ' +
            ('HEALTH_INSURANCE_STATIC_TEXT2' | translate)
          "
          [items]="tableCodeValue('THIRDPARTYPOLICYTYP', 'data.coverageType')"
          formControlName="coverageType"
          (change)="coverageTypeChange()"
        ></select>
      </nh-field>
      @if (isPolicyNameAndCompanyAlertMsgEnabled &&
      getControl('data.coverageType')?.value) {
      <nh-alert type="warning" [isOpen]="true">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            @if (isPolicyNameAndCompanySelected) {
            <span [innerHTML]="'POLICY_NAME_AND_COMPANY_ALERT_MSG' | translate">
            </span>
            } @if (!isPolicyNameAndCompanySelected) {
            <span [innerHTML]="'POLICY_NO_ALERT_MSG' | translate"> </span>
            }
          </div>
        </div>
      </nh-alert>
      } @if (isEnabled('data.insuranceCompanyName')) {
      <nh-field
        id="heco_insuranceCompanyName"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT3' | translate }}"
        class="label-section"
      >
        <input
          type="text"
          name="insuranceCompanyName"
          maxlength="40"
          class="form-control"
          formControlName="insuranceCompanyName"
          [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT3' | translate"
        />
      </nh-field>
      } @if (isEnabled('data.longTermCarePremiumAmount')) {
      <nh-field
        id="heco_longTermCarePremiumAmount"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT4' | translate }}"
        class="label-section"
      >
        <br />
        <span class="unbold">
          {{ "HEALTH_INSURANCE_STATIC_TEXT16" | translate }}
        </span>
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'HEALTH_INSURANCE_STATIC_TEXT5' | translate }}"
        ></nh-popover>
        <nh-input-group prepend="$">
          <input
            nh
            type="text"
            placeholder="0.00"
            mask="separator.2"
            thousandSeparator=""
            separatorLimit="999999999"
            name="longTermCarePremiumAmount"
            formControlName="longTermCarePremiumAmount"
            [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT4' | translate"
            class="form-control"
          />
        </nh-input-group>
      </nh-field>
      }

      <nh-field
        id="heco_policyNumber"
        label="{{ 'POLICY_NUMBER' | translate }}"
        [mandatory]="policyNumber"
        [attr.aria-required]="policyNumber"
        class="label-section"
      >
        <input
          type="text"
          name="policyNumber"
          class="form-control"
          formControlName="policyNumber"
          maxlength="16"
          [attr.aria-label]="'POLICY_NUMBER' | translate"
        />
      </nh-field>

      <nh-field
        id="heco_groupNumber"
        label="{{ 'GROUP_NUMBER' | translate }}"
        [mandatory]="groupNumber"
        [attr.aria-required]="groupNumber"
        class="label-section"
      >
        <input
          type="text"
          name="groupNumber"
          class="form-control"
          formControlName="groupNumber"
          maxlength="16"
          [attr.aria-label]="'GROUP_NUMBER' | translate"
        />
      </nh-field>

      @if (youngerIndividual && isEnabled('data.monthlyPremiumAmountForKB')) {
      <nh-field
        id="heco_monthlyPremiumAmountForKB"
        [mandatory]="groupNumber"
        [attr.aria-required]="groupNumber"
        label="{{ 'PREMIUM_ACCOUNT' | translate }}"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'PREMIUM_ACCOUNT_STATIC_TEXT' | translate }}"
        ></nh-popover>
        <nh-input-group prepend="$">
          <input
            nh
            type="text"
            placeholder="0.00"
            mask="separator.2"
            thousandSeparator=""
            separatorLimit="999999999"
            name="monthlyPremiumAmountForKB"
            formControlName="monthlyPremiumAmountForKB"
            [attr.aria-label]="'PREMIUM_ACCOUNT_STATIC_TEXT' | translate"
            class="form-control"
          />
        </nh-input-group>
      </nh-field>
      }

      <nh-field
        id="heco_policyStartDate"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT6' | translate }}"
        [mandatory]="groupNumber"
        [attr.aria-required]="groupNumber"
        class="label-section"
      >
        <nh-datepicker>
          <input
            type="text"
            name="policyStartDate"
            class="form-control"
            formControlName="policyStartDate"
            (change)="isInvalidDate($event)"
            [minDate]="minimumDate"
            bsDatepicker
            nh
            [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT6' | translate"
          />
        </nh-datepicker>
      </nh-field>

      @if (youngerIndividual && isEnabled('data.purchaseInsFromYourEmplyerSw'))
      {
      <nh-field
        id="heco_purchaseInsFromYourEmplyerSw"
        [labelSize]="false"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT7' | translate }}"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'HEALTH_INSURANCE_STATIC_TEXT8' | translate }}"
        ></nh-popover>
        <select
          nh
          name="purchaseInsFromYourEmplyerSw"
          [items]="tableCodeValue('YESNO', 'data.purchaseInsFromYourEmplyerSw')"
          formControlName="purchaseInsFromYourEmplyerSw"
          [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT7' | translate"
        ></select>
      </nh-field>
      } @if (isEnabled('data.stateEmployeeBenfitPlanSwitch')) {
      <nh-field
        id="heco_stateEmployeeBenfitPlanSwitch"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT9' | translate }}"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'HEALTH_INSURANCE_STATIC_TEXT10' | translate }}"
        ></nh-popover>
        <select
          nh
          name="stateEmployeeBenfitPlanSwitch"
          [items]="
            tableCodeValue('YESNO', 'data.stateEmployeeBenfitPlanSwitch')
          "
          formControlName="stateEmployeeBenfitPlanSwitch"
          [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT9' | translate"
        ></select>
      </nh-field>
      } @if (isEnabled('data.limitedBenefitPlanSwitch')) {
      <nh-field
        id="heco_limitedBenefitPlanSwitch"
        [mandatory]="limitedPlan"
        [attr.aria-required]="limitedPlan"
        [labelSize]="false"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT11' | translate }}"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'HEALTH_INSURANCE_STATIC_TEXT12' | translate }}"
        ></nh-popover>
        <select
          nh
          name="limitedBenefitPlanSwitch"
          [items]="tableCodeValue('YESNO', 'data.limitedBenefitPlanSwitch')"
          formControlName="limitedBenefitPlanSwitch"
          [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT11' | translate"
          [attr.aria-required]="limitedPlan"
        ></select>
      </nh-field>
      }

      <nh-field
        id="heco_coverMaternityBenefitsSwitch"
        label="{{ 'HEALTH_INSURANCE_STATIC_TEXT13' | translate }}"
        [mandatory]="groupNumber"
        [attr.aria-required]="groupNumber"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          content="{{ 'HEALTH_INSURANCE_STATIC_TEXT14' | translate }}"
        ></nh-popover>
        <select
          name="coverMaternityBenefitsSwitch"
          [attr.aria-label]="'HEALTH_INSURANCE_STATIC_TEXT13' | translate"
          [items]="tableCodeValue('YESNO', 'data.coverMaternityBenefitsSwitch')"
          formControlName="coverMaternityBenefitsSwitch"
          nh
        ></select>
      </nh-field>

      <div>
        <label for="Health Coverage" class="label-section"
          ><span class="text-danger" aria-hidden="true">*</span
          >{{ "HEALTH_INSURANCE_STATIC_TEXT15" | translate }}</label
        >
        @for (choice of list; track choice; let i = $index) {
        <div class="mt-2 pt-2">
          <div class="form-check pb-md-1 checkbox">
            <label class="form-check-label mt-2">
              <input
                id="{{ 'coveredIndividualNumber' + i }}"
                type="checkbox"
                tabindex="0"
                class="form-check-input"
                [value]="choice.coveredIndividualNumber"
                [attr.aria-label]="
                  choice.name + ', ' + choice.age + choice.gender
                "
                [attr.aria-required]="true"
                (click)="onCheckChange($event)"
                [checked]="choice.checked"
              />
              <span class="cr"
                ><i class="cr-icon fa fa-check" aria-hidden="true"></i
              ></span>
              {{ choice.name }}, {{ choice.age + choice.gender }}
            </label>
          </div>
        </div>
        }
      </div>
    </fieldset>
  </section>

</nh-form>
